import { COLORS } from "../../../common/consts/colors";
import type { IconProps } from "./type";

export default function FilterIcon({ color = "purple" }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        d="M4.66699 8H20.667M7.66699 12H17.667M10.667 16H14.667"
        stroke={COLORS[color]}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
